import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function TesisDeMaestria() {
  return <ServiceTemplate serviceName="tesis-de-maestria" />;
}
